<div class="couponFromExisting">
  <div class="ui-g">
    <div class="ui-g-6">
      <div class="c3_actionTypeContainer">
        <div class="c3_actionType" [ngStyle]="{'width': '50%' }"
          [ngClass]="{'actionTypeActive': choiceCode == 'PREFERRED' }" (click)="onClickPreferred()">{{
          'campaign.select_from_favorites' | translate }}</div>
        <div class="c3_actionType" [ngStyle]="{'width': '50%' }"
          [ngClass]="{'actionTypeActive': choiceCode == 'OTHER' }" (click)="onClickOtherAction()">{{
          'campaign.select_other_action' | translate }}</div>
        <div class="clear_fix"></div>
      </div>
    </div>
    <div class="ui-g-6 ui-g">
      <div class="ui-g-6 text-right">
        <div class="c3_element_title">{{ 'campaign.duplicate_action_name' | translate }} <span class="asterix">*</span>
        </div>
      </div>
      <div class="ui-g-6" id="new_name">
        <app-form-fields #new_name [(fieldModel)]="fieldModel.new_name" [name]="'new_name'" [required]="true"
          [label]="''" [type]="'string'" [maxLength]="200"></app-form-fields>

        <!--<input type="text" [ngClass]="{'errorField': valid == false }" required="true" [(ngModel)]="fieldModel.new_name" maxlength="100" pInputText />-->
      </div>
    </div>
  </div>
  <div class="couponTable" *ngIf="show.tablePreferred==true">

    <app-campaign-3-kontable id="couponTable" [columns]="[
    { field: 'name', title: 'Nome Azione' },
    { field: 'notes', title: 'Note Interne', filterType: customFilter, filterTemplate: intNoteFilter }
    ]" [paginationType]="paginationType" [showInfoButton]="false" [showGlobalFilter]="false"
      [showDetailsButton]="false" [showAddButton]="false" [showDeleteButton]="false" [showEditButton]="false"
      [toolbarCustomButtons]="customButtons" [service]="srvCampaign" [additionalRowCommands]="actions"
      [allowSelectRow]="true" (onSelected)="onPreferredSelected($event)"
      [methodsNames]="{ list: 'getPreferredCoupons', sendExtSearchQuery: 'sendExtSearchQuery' }" #couponTable>

      <ng-template #intNoteFilter let-col>
        <span></span>
      </ng-template>

      <ng-template #customButtons>

      </ng-template>

      <ng-template #actions let-row>

        <div class="d-flex justify-content-center">
          <!--
            <button pTooltip="{{ 'common.edit' | translate }}" class="deletebutton"
              (click)="onDeleteFromFavourite(row)">
                <i class="pi pi-trash icon-size"></i>
            </button>
          -->
        </div>

      </ng-template>

    </app-campaign-3-kontable>
  </div>

  <div class="couponTable ui-g">
    <br />
    <br />
    <div class="ui-g-6 ui-g" *ngIf="choiceCode == 'OTHER' && show.comboCampaign">
      <div class="ui-g-3 labelTitle">{{ 'campaign.campaign' | translate }}<span class="asterix"
          *ngIf="required && showRequiredAsterix">&nbsp;*</span></div>
      <div class="ui-g-9">
        <app-form-fields #campagna (fieldModelChange)="onChangeCampaignSelected($event)" [label]="''"
          [(fieldModel)]="fieldModel.campaign" [type]="'dropdown'" [options]="comboCampagne" [name]="'campagna'"
          [optionLabel]="'name'" [placeholder]="'campaign.select_campaign' | translate"
          [required]="true" [filterable]="true"></app-form-fields>
      </div>
    </div>
    <div class="ui-g-6 ui-g" *ngIf="choiceCode == 'OTHER' && show.comboCampaign">
      <div class="ui-g-3 labelTitle">{{ 'campaign.campaign_action' | translate }}<span class="asterix"
          *ngIf="required && showRequiredAsterix">&nbsp;*</span></div>
      <div class="ui-g-9">
        <app-form-fields #azione (fieldModelChange)="onMessageInstanceSelected($event)" [label]="''"
          [(fieldModel)]="fieldModel.action" [type]="'dropdown'" [options]="campaignList" [name]="'azione'"
          [optionLabel]="'name'" [placeholder]="'campaign.select_action' | translate"
          [required]="true" [filterable]="true"></app-form-fields>
      </div>
    </div>


    <div class="ui-g-12 ui-g" *ngIf="show.duplicateForm==true">

      <div class="infoContainer ui-g-12">
        {{ 'campaign.date_validity' | translate }} <b>{{ campaignInfoTo.name }}</b>: <b>dal {{ campaignInfoTo.dateStart
          | date :dateFormat }} al {{ campaignInfoTo.dateEnd | date :dateFormat }}</b>
      </div>
      <!-- emissione -->
      <div class="ui-g ui-g-6 displayBlock">
        <br />
        <br />
        <div class="title">{{ 'campaign.select_emission_period_coupon' | translate }}<span class="asterix">*</span>&nbsp; <i
            class="fa fa-info-circle icon"
            pTooltip="E' l'intervallo di tempo in cui i tuoi coupon saranno distribuiti"></i></div>
        <br />
        <br />
        <span class="switchTitle" id="switchAsCampaign"><p-inputSwitch (onChange)="onChangeAsCampaign()"
            [(ngModel)]="switch.asCampaign">
          </p-inputSwitch>&nbsp;{{ 'campaign.as_campaign' | translate }}
        </span>

          <br />
          <br />
          <app-form-fields #existing_data_inizio_emissione [required]="true" [showRequiredAsterix]="false"
            [label]="'Data inizio emissione'" [minDate]="campaignInfoTo.dateStart"
            [maxDate]="campaignInfoTo.dateEnd" [(fieldModel)]="fieldModel.data_inizio_emissione" [type]="'date'"
            [name]="'existing_data_inizio_emissione'" [placeholder]="'campaign.select_start_date_emission' | translate"
            (fieldModelChange)="onChangeInizioEmissione($event)"></app-form-fields>
          <br />
          <app-form-fields #existing_data_fine_emissione [required]="true" [showRequiredAsterix]="false"
            [label]="'Data fine emissione'" [minDate]="campaignInfoTo.dateStart" [maxDate]="campaignInfoTo.dateEnd"
            [(fieldModel)]="fieldModel.data_fine_emissione" [type]="'date'" [name]="'existing_data_fine_emissione'"
            [placeholder]="'campaign.select_end_date_emission' | translate"
            (fieldModelChange)="onChangeFineEmissione($event)"></app-form-fields>
      </div>
      <br /><br />
      <br /><br />
      <div class="articoloCouponBox ui-g ui-g-6">
        <div class="ui-g-12 title">{{ 'campaign.message_item' | translate }}</div>

        <div class="ui-g-2">
          <div class="fa fa-search circleIcon"
            [ngClass]="{'notPermitted': switch.soloBarcode, 'pointer':  !switch.soloBarcode }"
            (click)="onClickSearchArticolo()"></div>
        </div>
        <div class="ui-g-10">
          <app-form-fields #existingArticoloCoupon (fieldModelChange)="onChangeArticoloCoupon($event)" [label]="''"
            [(fieldModel)]="fieldModel.articoloCoupon.articolo" [type]="'dropdown'"
            (filterDropdownChanged)="onChangedFilterArticolo($event)"
            [serverOptions]="{service: srvCampaign, methodName: 'getProductItemCompleteOnlyBarcode', filterField: 'description', groupByField: 'id', groupedFieldArray: {fieldName: 'barcode', newFieldName: 'barcodes'}}"
            [name]="'articoloCoupon'" [optionLabel]="'description'" [placeholder]="'campaign.select_action' | translate"
            [required]="true"></app-form-fields>
        </div>
        <div class="ui-g-12 ui-g">
          <div class="ui-g-4">
            <app-form-fields #existingSoloBarcode (checkboxChanged)="onChangeSoloBarcode($event)"
              [(fieldModel)]="switch.soloBarcode" [type]="'checkbox'" [label]="'Solo Barcode'"
              [name]="'soloBarcode'"></app-form-fields>
          </div>
          <div class="ui-g-8">
            <div class="">{{ 'campaign.coupon_barcode' | translate }}<span class="asterix"></span></div>
            <app-form-fields *ngIf="existingSoloBarcode.fieldModel" #existingSoloBarcodeText [required]="true"
              [(fieldModel)]="fieldModel.barcodeManualCoupon" [name]="'existingSoloBarcodeText'" [label]="''"
              [type]="'string'"></app-form-fields>
            <app-form-fields *ngIf="!existingSoloBarcode.fieldModel" #existingComboBarcodes [label]="''"
              [optionLabel]="'barcode'" [(fieldModel)]="fieldModel.articoloCoupon.barcode" [type]="'dropdown'"
              [options]="comboBarcodes" [required]="true" [name]="'comboBarcodes'"
              [placeholder]="'xxxxxxxxxxxxxxxxx'"></app-form-fields>
          </div>
        </div>
      </div>
    </div>



  </div>




  <p-dialog *ngIf="show.modalProductList" [width]="1500" [height]="800" [(visible)]="show.modalProductList"
    [responsive]="true"[header]=" 'campaign.search_article' | translate " showEffect="fade" [modal]="true" [appendTo]="'body'">

    <app-campaign-3-search-product-barcode #searchProduct
      (productSelected)="onProductSelected($event)"></app-campaign-3-search-product-barcode>

    <!-- Bottoni Annulla e Conferma -->
    <div class="ui-dialog-footer buttonsContainer">
      <button pButton (click)="onClickAnnulla_ModalArticoli()" type="button" class="k-generic-btn footer-btn"
        label="{{'common.cancel' | translate}}"></button>

      <div class="clear_fix"></div>
    </div>

  </p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/campaing-3-message/message-3-info-base/create-message-from-existing/create-message-from-existing.component.html